import { MINUTES, SECONDS } from "@zenith/data/constants";

/**
 * Formats the time (in seconds) to show the counter
 * using the '00h:00m:00s' format.
 * @function
 * @name formatTimeForCounter
 * @kind function
 * @param {number} timeInSeconds Time in seconds.
 * @param {("seconds" | "minutes" | "hours")=} timeFormat The time format.
 * @returns {string} A string with the formatted time.
 * @exports
 */
export function formatTimeForCounter(
  timeInSeconds: number,
  timeFormat: "seconds" | "minutes" | "hours" = "minutes"
): string {
  const hours = Math.floor(timeInSeconds / MINUTES)
    .toString()
    .padStart(2, "0");

  const minutes = Math.floor((timeInSeconds % MINUTES) / SECONDS)
    .toString()
    .padStart(2, "0");

  const seconds = (timeInSeconds % SECONDS).toString().padStart(2, "0");

  switch (timeFormat) {
    case "seconds":
      return `${seconds}s`;
    case "hours":
      return `${hours}h:${minutes}m:${seconds}s`;
    case "minutes":
      return `${minutes}m:${seconds}s`;
    default:
      throw new Error("Time format not implemented");
  }
}
